export default "__VITE_PUBLIC_ASSET__b568fbe5__"